import tw from 'twin.macro';

export const StyledP = tw.p`
  first-letter:capitalize font-medium text-base leading-[1.313rem] 
`;
